import React, { forwardRef } from 'react';
import { Switch as MuiSwitch, FormControlLabel } from '@material-ui/core';
import { useDsTokens } from '../theme/useDsTokens';
import { cn } from '../utils/cn';
import { DsCommonProps, DsValidationProps } from './types';

export interface SwitchProps extends DsCommonProps, DsValidationProps {
  checked?: boolean;
  defaultChecked?: boolean;
  name?: string;
  value?: string;
  label?: React.ReactNode;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

export const Switch = forwardRef<HTMLButtonElement, SwitchProps>(function Switch(
  {
    id,
    className,
    disabled,
    error,
    required,
    checked,
    defaultChecked,
    name,
    value,
    label,
    inputProps,
    onChange,
    'data-testid': testId,
  },
  ref
) {
  const tokens = useDsTokens();

  const control = (
    <MuiSwitch
      id={id}
      ref={ref}
      className={cn(className)}
      data-testid={testId}
      color="primary"
      checked={checked}
      defaultChecked={defaultChecked}
      disabled={disabled}
      required={required}
      name={name}
      value={value}
      inputProps={{
        ...inputProps,
        role: 'switch',
        'aria-invalid': error ? true : undefined,
      }}
      onChange={onChange}
      style={{
        opacity: disabled ? tokens.opacityDisabled : 1,
      }}
    />
  );

  if (label) {
    return (
      <FormControlLabel
        control={control}
        label={label}
        disabled={disabled}
        style={{
          color: disabled ? tokens.textDisabled : tokens.textPrimary,
          fontSize: tokens.fontSizeBody,
        }}
      />
    );
  }

  return control;
});

Switch.displayName = 'Switch';
